// ----------------------------------------------------------------------

const account = {
  displayName: 'Admin',
  email: 'example@domain.com',
  photoURL: `${process.env.PUBLIC_URL}/assets/images/avatars/avatar_default.jpg`,
};

export default account;
